// extracted by mini-css-extract-plugin
export default {"support":"index_support_4nUCN","title":"index_title_aYTY6","image":"index_image_lbbxE"};